import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { SearchModel } from 'shared/search/search.model';
import { StatusModel } from 'shared/search/status.model';
import { LACT, SACT } from './pim-config';
import { PermissionsService } from 'shared/permissions/permissions.service';


@Component({
  moduleId: module.id,
  selector: 'contextual-action',
  template: '',
  styleUrls: ['contextual-action.component.scss'],
})
export class ContextualActionComponent {
  @Output() actionSelected = new EventEmitter();
  @Input() selectedRows: Array<{}> = [];
  @Input() size: number = 0;
  @Input() allSelected: boolean = false;
  @Input() searchModel: SearchModel;
  @Input() statusModel: StatusModel;
  @Input() listFilters: Array<any>;

  listActions = [
    {
      id: LACT.ADD_TO_LIST.id,
      action: LACT.ADD_TO_LIST.name,
      title: 'Add to list',
      active: false,
    },
    {
      id: LACT.REMOVE_FROM_LIST.id,
      action: LACT.REMOVE_FROM_LIST.name,
      title: 'Remove from list',
      active: false,
    },
  ];

  secondaryActions = [
    {
      id: SACT.VIEW_DETAILS.id,
      action: SACT.VIEW_DETAILS.name,
      title: 'View details',
      active: true,
    },
    {
      id: SACT.EDIT_SELECTED.id,
      action: SACT.EDIT_SELECTED.name,
      title: 'Edit selected',
      active: true,
    },
    {
      id: SACT.VIEW_SELECTED.id,
      action: SACT.VIEW_SELECTED.name,
      title: 'View selected',
      active: true,
    },
    {
      id: SACT.BULK_EDIT.id,
      action: SACT.BULK_EDIT.name,
      title: 'Bulk edit',
      active: true,
    },
  ];

  constructor(
    protected permissionsService: PermissionsService
  ) { }

  get selectedRowsSize(): number|string {
    // if selected all items return total records length
    if (this.allSelected) {
      return `about ${this.size}`;
    }
    // if there is no sort by status return all selected rows length
    if (!this.statusModel) {
      return this.selectedRows.length;
    }
    // filter by status if status was choosen
    return _.filter( this.selectedRows, ['status',
      this.statusModel.id
    ]).length;
  }

  handleAddToListClick() {
    this.actionSelected.emit(this.listActions[0]);
  }

  handleViewDetailsClick() {
    this.emitSelectedAction(this.secondaryActions[0]);
  }

  emitSelectedAction(action: any) {
    this.actionSelected.emit(action);
  }

  hasPermission(allow: Array<string>|string, requireAll: boolean= false): boolean {
    return this.permissionsService.hasPermission(allow, requireAll);
  }
}
